<template>
  <div class="topnav-product-highlight-container">
    <NsProductCard
      v-for="sku in localSkus"
      :key="sku"
      class="topnav-product-highlight"
      no-action
      hide-variant-selector
      hide-favorites
      :sku="sku"
    />
  </div>
</template>

<script>
import { NsProductCard } from "@nuskin/product-components";

export default {
  name: "NsTopnavProductHighlight",
  components: { NsProductCard },
  props: {
    /**
     * Skus (max: 3)
     * [{sku}]
     */
    skus: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localSkus: []
    };
  },
  mounted: function() {
    this.localSkus = JSON.parse(this.skus).filter(sku => !!sku);
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.topnav-product-highlight-container {
  display: flex;
  margin-left: 113px;
  padding: 10px 20px;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.topnav-product-highlight {
  max-width: 220px;
  min-width: 160px;
}

@media (max-width: 1023px) {
  .topnav-product-highlight-container {
    flex-direction: column;
    align-items: center;
    margin: 0;

    .topnav-product-highlight {
      width: 100%;
    }
  }
}
</style>
